'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDnd = require('react-dnd');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('components/ListItem/ListItem.scss');

var cn = _bind2.default.bind(styles);

var cardSource = {
  beginDrag: function beginDrag(props) {
    return {
      id: props.id,
      index: props.index,
      children: props.children
    };
  },
  endDrag: function endDrag(props) {
    props.onDrop();
  }
};

var cardTarget = {
  hover: function hover(props, monitor, component) {
    var dragIndex = monitor.getItem().index;
    var hoverIndex = props.index;
    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }
    // Determine rectangle on screen
    var hoverBoundingRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect(); // eslint-disable-line react/no-find-dom-node
    // Get vertical middle
    var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    // Determine mouse position
    var clientOffset = monitor.getClientOffset();
    // Get pixels to the top
    var hoverClientY = clientOffset.y - hoverBoundingRect.top;
    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%
    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }
    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }
    // Time to actually perform the action
    props.onMove(dragIndex, hoverIndex);
    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  }
};

var SortableListItem = (_dec = (0, _reactDnd.DropTarget)('listItem', cardTarget, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}), _dec2 = (0, _reactDnd.DragSource)('listItem', cardSource, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SortableListItem, _Component);

  function SortableListItem() {
    (0, _classCallCheck3.default)(this, SortableListItem);
    return (0, _possibleConstructorReturn3.default)(this, (SortableListItem.__proto__ || (0, _getPrototypeOf2.default)(SortableListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(SortableListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          connectDragSource = _props.connectDragSource,
          connectDropTarget = _props.connectDropTarget,
          connectDragPreview = _props.connectDragPreview,
          isDragging = _props.isDragging,
          isTitle = _props.isTitle,
          fullWidth = _props.fullWidth,
          className = _props.className,
          hideDragHandler = _props.hideDragHandler,
          isLocked = _props.isLocked,
          onMove = _props.onMove,
          index = _props.index,
          props = (0, _objectWithoutProperties3.default)(_props, ['children', 'connectDragSource', 'connectDropTarget', 'connectDragPreview', 'isDragging', 'isTitle', 'fullWidth', 'className', 'hideDragHandler', 'isLocked', 'onMove', 'index']); // eslint-disable-line no-unused-vars

      var itemClass = cn(className, 'listItemRoot', { listItemTitle: isTitle, fullWidth: fullWidth, invisible: isDragging });

      if (hideDragHandler) {
        var node = _react2.default.createElement(
          'li',
          (0, _extends3.default)({ className: itemClass }, props),
          children
        );
        return connectDropTarget(connectDragPreview(isLocked ? node : connectDragSource(node)));
      }

      return connectDropTarget(connectDragPreview(_react2.default.createElement(
        'li',
        (0, _extends3.default)({ className: itemClass }, props),
        isLocked ? _react2.default.createElement('div', null) : connectDragSource(_react2.default.createElement(
          'div',
          { className: styles.dragHandler },
          _react2.default.createElement('i', { className: 'icon-import-export' })
        )),
        children
      )));
    }
  }]);
  return SortableListItem;
}(_react.Component), _class2.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  className: _propTypes2.default.string,
  connectDragPreview: _propTypes2.default.func,
  connectDragSource: _propTypes2.default.func,
  connectDropTarget: _propTypes2.default.func,
  fullWidth: _propTypes2.default.bool,
  hideDragHandler: _propTypes2.default.bool,
  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
  index: _propTypes2.default.number.isRequired,
  isDragging: _propTypes2.default.bool,
  isLocked: _propTypes2.default.bool,
  isTitle: _propTypes2.default.bool,
  onDrop: _propTypes2.default.func.isRequired,
  onMove: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class);
exports.default = SortableListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SortableList/SortableListItem.js
// module id = 2106
// module chunks = 1